module.exports = __webpack_public_path__ + "img/marker_montagne.33671b0c.svg";